import React, {Component} from 'react';
import firebase from '../data/firebase.js';
import ListMaker from '../helpers/listMaker';
import DymnamicBackground from "../components/DynamicBackground";

class ClientList extends Component {
  constructor() {
    super();
    this.state = {
      items: []
    }
  }

  componentDidMount() {
    const itemsRef = firebase.database().ref().child('clients');
    itemsRef.on('value', (snapshot) => {
      let items = snapshot.val();
      let newState = [];
      for (let item in items) {
        newState.push({
          id: item.id,
          title: items[item].title,
          intro: items[item].intro,
          clients: items[item].list,
        });
      }
      this.setState({
        items: newState
      });
    });
  }

  render() {
    return (
      <div>
        <section className="container">
          {this.state.items.map((item, i) => {
            return (
              <div key={i}>
                <h1>{item.title}</h1>
                <h2>{item.intro}</h2>
                <hr/>
                <div className="align-left-top">
                  <ListMaker type="clients" list={item.clients}></ListMaker>
                </div>
              </div>
            )
          })}
        </section>
      </div>
    );
  }
}

export default ClientList;